export type VatNumberValidation = '' | 'VALID' | 'UNKNOWN' | 'INVALID' | 'PENDING' | 'SKIP'

export enum UiSetup {
  Invoicing = 'invoicing',
  SupernavInvoicingAccounting = 'supernav_invoicing_accounting',
  ShineInvoicingAccounting = 'shine_invoicing_accounting',
}

export enum ShineMigrationStatus {
  HistoricalSyncScheduled = 'HISTORICAL_SYNC_SCHEDULED',
}
export interface UserInterface {
  id: string
  firstname: string
  lastname: string
  email: string
  language: string
  admin: boolean
  type: string
  currentUser: boolean
}

export interface CompanyInterface {
  language: string
  locale?: string
  businessId: string
  country: string
  email: string | null
  globalId: string
  id: number
  vatNumber: string
  rcs?: string
  legalStatus?: string
  name?: string
  vatPct?: number
  currencyId: number
  baseInvoiceNumber?: number
  users?: UserInterface[]
  vat?: number
  phoneNumber?: string
  firstName?: string
  lastName?: string
  marketplaceToken?: string
  vatNumberValidation?: VatNumberValidation
  randomBucket: number
  agerasNextMigration?: boolean | null
  externalOrganisationId: string | null
  userId: number
  insertTime: string
  isNotVATLiable?: boolean | null
  uiSetup: UiSetup
  shineMigrationStatus?: ShineMigrationStatus | null
}

interface CompanyAddressInterface {
  city?: string
  einvoicingAddress?: any
  postCode?: string
  streetAddress1?: string
  streetAddress2?: string
  web?: string
}

interface CompanyContactInterface {
  email?: string
  firstName?: string
  lastName?: string
  mobilePhoneNumber?: string
  phoneNumber?: string
}

interface VatInformation {
  number?: string | null
  returnPeriod?: string // clarify
  vatPct?: number
  verification?: VatNumberValidation
}

export interface CompanyPlatformInterface {
  vatNumber: string
  addressInformation?: CompanyAddressInterface
  contactInformation?: CompanyContactInterface
  country: string
  currencyId?: number
  email: string
  globalId: string
  id: number
  language: string
  logoId?: number
  name?: string
  registrationNumber?: string
  vatNumberValidation?: VatNumberValidation
  vatInformation?: VatInformation
  randomBucket: number
  agerasNextMigration?: boolean
  userId: number
  insertTime: string
  externalOrganisationId: string | null
  uiSetup: UiSetup
  shineMigrationStatus?: ShineMigrationStatus | null
}

export interface LogoURLInterface {
  url: string
  logoId: number
}
